<template>
  <transition name="fade">
    <b-card no-body class="w-100">
      <div slot="header">
        Stats
      </div>
      <b-card-body>
        <div v-if="isEmpty" class="text-center">
          No data available
        </div>
        <ul v-else class="stats">
          <li>
            <p>Voyages:</p>
            <p>{{ statsComputed.voyages }}</p>
          </li>
          <li>
            <p>Volume:</p>
            <p>{{ statsComputed.volume }}</p>
          </li>
          <li>
            <p>Unique origin ports:</p>
            <p>{{ statsComputed.uniqueOriginPorts }}</p>
          </li>
          <li>
            <p>Unique destination ports:</p>
            <p>{{ statsComputed.uniqueDestinationPorts }}</p>
          </li>
          <li>
            <p>Unique vessels:</p>
            <p>{{ statsComputed.uniqueVessels }}</p>
          </li>
        </ul>

      </b-card-body>
    </b-card>
  </transition>
</template>

<script>
  import {
    formatCount,
    formatVolume,
  } from '@/shared/number-utils'

  export default {
    name: 'movements-stat',
    props: {
      stats: {
        type: Object,
        default: () => ({}),
      },
    },

    data() {
      return {};
    },

    computed: {
      statsComputed: function () {
        if(this.stats) {
          let stats = this.stats;
          return {
            ...stats,
            volume: formatVolume(stats.volume),
            voyages: formatCount(stats.voyages),
            uniqueVessels: formatCount(stats.uniqueVessels),
          }
        } else {
          return {};
        }
      },
      isEmpty: function () {
        return !Object.keys(this.stats).length;
      }
    }
  }
</script>

<style lang="scss" scoped>
  .stats {
    list-style: none;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      border-bottom: 1px solid gray;
      padding-bottom: 5px;
      margin-bottom: 20px;
      p:last-child {
        font-weight: 600;
      }
    }
    p {
      margin: 0;
    }

  }
</style>
